<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable vue/no-v-for-template-key -->
<template>
  <section class="quotewizard">
    <loader :loading="loading"></loader>
    <div class="container">
      <div class="subtitle" style="text-align: center">
        Review Your Purchase
      </div>
      <br />
      <div class="reviewleft">
        <!--------------------------->
        <div class="reviewtable">
          <!-------------- review table --------------->
          <h4>
            Your Coverage Details
            <a href="" class="edit" @click.prevent="quoteCoverage()">Edit</a>
          </h4>
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td valign="top">Policy Term</td>
                <td valign="top">{{ quote.info.policyLength }} Year</td>
              </tr>
              <tr>
                <td valign="top" width="55%">Coverage Start Date</td>
                <td valign="top">
                  {{ formatDate(quote.info.coverageStartDate) }}
                </td>
              </tr>
              <tr>
                <td valign="top">Your liability</td>
                <td valign="top">
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td valign="top">Personal Property Coverage</td>
                <td valign="top">
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails
                        .personalPropertyAmount
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td valign="top">Deductible</td>
                <td valign="top">
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails.deductible
                    )
                  }}
                </td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.hurricaneDeductible != null">
                <td valign="top">Hurricane Deductible</td>
                <td valign="top">
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails
                        .hurricaneDeductible
                    )
                  }}
                </td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.replacementCost">
                <td valign="top">Replacement Cost</td>
                <td valign="top">Included</td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.waterBackup">
                <td valign="top">Water / Sewer Backup</td>
                <td valign="top">Added</td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.identityFraud">
                <td valign="top">Fraud Expense Protection</td>
                <td valign="top">Added</td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.earthquake">
                <td valign="top">Earthquake</td>
                <td valign="top">Added</td>
              </tr>
              <tr>
                <td valign="top">Payment Plan</td>
                <td valign="top">
                  {{
                    formatPaymentOption(quote.rentersInsurance.paymentOption)
                  }}
                </td>
              </tr>
              <tr>
                <td valign="top">Accidental Damage Personal Property Add-On</td>
                <td valign="top">
                  {{ quote.hasPersonalInsurance ? "Added" : "N/A" }}
                </td>
              </tr>
              <tr>
                <td valign="top">
                  Accidental Damage Personal Property Coverage
                </td>
                <td valign="top">
                  {{
                    quote.hasPersonalInsurance
                      ? formatAmountWithoutCents(
                          quote.personalInsurance.coverageAmount
                        )
                      : "N/A"
                  }}
                </td>
              </tr>
              <tr>
                <td valign="top">
                  Accidental Damage Personal Property Deductible
                </td>
                <td valign="top">
                  {{
                    quote.hasPersonalInsurance
                      ? quote.personalInsurance.deductibleAmountText
                      : "N/A"
                  }}
                </td>
              </tr>
              <tr>
                <td valign="top">
                  Accidental Damage Personal Property Payment Plan
                </td>
                <td valign="top">
                  {{
                    formatPaymentOption(quote.personalInsurance.paymentOption)
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-------------- review table --------------->
        <div class="reviewtable">
          <h4>
            Your Information
            <a href="" class="edit" @click.prevent="quoteCheckout()">Edit</a>
          </h4>
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="collapserowmobile"
          >
            <tbody>
              <tr>
                <td valign="top" width="55%">Policyholder</td>
                <td valign="top">
                  {{ quote.checkout.info.firstName }}
                  {{ quote.checkout.info.lastName }}
                </td>
              </tr>
              <tr>
                <td valign="top">Date of Birth</td>
                <td valign="top">{{ formatDate(quote.checkout.info.dob) }}</td>
              </tr>
              <tr>
                <td valign="top">Phone Number</td>
                <td valign="top">
                  {{ formatPhoneNumber(quote.checkout.info.phone) }}
                </td>
              </tr>
              <tr>
                <td valign="top">Email</td>
                <td valign="top">{{ quote.checkout.info.email }}</td>
              </tr>
            </tbody>
          </table>
          <hr />
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr></tr>
              <tr>
                <td valign="top" width="55%">Roommate(s)</td>
                <td valign="top">
                  <template
                    v-for="roommate in quote.checkout.roommates"
                    :key="
                      'roommate-' + quote.checkout.roommates.indexOf(roommate)
                    "
                  >
                    {{ roommate.firstName }} {{ roommate.lastName }}<br />
                  </template>
                </td>
              </tr>
              <tr v-if="quote.checkout.interestedParty.firstName !== ''">
                <td valign="top">Interested Party</td>
                <td valign="top">
                  {{
                    quote.checkout.interestedParty.firstName +
                    " " +
                    quote.checkout.interestedParty.lastName
                  }}<br />
                  {{ quote.checkout.interestedParty.address.address }}
                  {{
                    quote.checkout.interestedParty.address.apt
                      ? ", Apt " + quote.checkout.interestedParty.address.apt
                      : ""
                  }}<br />
                  {{ quote.checkout.interestedParty.address.city }},
                  {{ quote.checkout.interestedParty.address.state.title }}
                  {{ quote.checkout.interestedParty.address.zip }}<br />
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td valign="top" width="55%">Property Address</td>
                <td valign="top">
                  {{ quote.address.address }}<br />
                  {{ quote.address.city }}, {{ quote.address.state.title }}
                  {{ quote.address.zip }}
                </td>
              </tr>
              <tr>
                <td valign="top">Mailing Address</td>
                <td valign="top">
                  <template v-if="quote.checkout.useSameAddressForMailing">
                    Same as property address
                  </template>
                  <template v-else>
                    {{ quote.checkout.mailingAddress.streetNumber }}
                    {{ quote.checkout.mailingAddress.address }}<br />
                    {{ quote.checkout.mailingAddress.city }}
                    {{ quote.checkout.mailingAddress.state.title }}
                    {{ quote.checkout.mailingAddress.zip }}
                  </template>
                </td>
              </tr>
              <tr>
                <td valign="top">School Information</td>
                <td valign="top">
                  {{ quote.checkout.schoolName }}<br />
                  {{ quote.checkout.schoolCity }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-------------- review table --------------->
      </div>
      <div class="reviewright">
        <!--------------------------->
        <div class="reviewtable">
          <h4>
            Payment Method
            <a href="" class="edit" @click.prevent="quoteCheckoutPayment()"
              >Edit</a
            >
          </h4>
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td valign="top" width="55%">Payment Type</td>
                <td valign="top">
                  <template v-if="quote.checkout.paymentMethod.creditCard">
                    Credit / Debit Card
                  </template>
                  <template v-else> Bank Account </template>
                </td>
              </tr>
              <template v-if="quote.checkout.paymentMethod.creditCard">
                <tr>
                  <td valign="top">Card Details</td>
                  <td valign="top">
                    {{
                      formatCardNumber(quote.checkout.paymentMethod.cardNumber)
                    }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <hr />
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td valign="top" width="55%">Billing Address</td>
                <td valign="top">
                  <template v-if="quote.checkout.paymentMethod.billingAddressType === 1">
                    Same as property address
                  </template>
                  <template v-else-if="quote.checkout.paymentMethod.billingAddressType === 2">
                    Same as mailing address
                  </template>
                  <template v-else>
                    {{
                      quote.checkout.paymentMethod.billingAddress.streetNumber
                    }}
                    {{ quote.checkout.paymentMethod.billingAddress.address
                    }}<br />
                    {{ quote.checkout.paymentMethod.billingAddress.city }}
                    {{
                      quote.checkout.paymentMethod.billingAddress.state.title
                    }}
                    {{ quote.checkout.paymentMethod.billingAddress.zip }}
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-------------- review table --------------->
        <div class="reviewtable">
          <h4>Total</h4>
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td valign="top" width="80%">
                  Assurant Renters Insurance Policy<br />
                  <span
                    v-if="quote.rentersInsurance.paymentOption != 2"
                    style="font-size: 12px"
                    >Your next payment of
                    {{
                      formatAmount(
                        quote.rentersInsurance.installmentAmount +
                          quote.rentersInsurance.serviceFee
                      )
                    }}
                    will be charged automatically on
                    {{ rentersNextPaymentDate }}
                    of the month.</span
                  >
                </td>
                <td valign="top">
                  {{ formatAmount(quote.rentersInsurance.dueToday) }}
                </td>
              </tr>
              <tr>
                <td valign="top">
                  NSSI Accidental Damage Personal Property Coverage Policy<br />
                  <template v-if="quote.hasPersonalInsurance">
                    <span
                      v-if="quote.personalInsurance.paymentOption != 2"
                      style="font-size: 12px"
                      >Your next payment of
                      {{
                        formatAmount(
                          quote.personalInsurance.retailPremium
                        )
                      }}
                      will be charged automatically on
                      {{ nssiNextPaymentDate }}
                      of the month.</span
                    >
                  </template>
                </td>
                <td valign="top">
                  {{
                    quote.hasPersonalInsurance
                      ? formatAmount(
                          quote.personalInsurance.dueToday
                        )
                      : "N/A"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <hr />
          <br />
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td valign="top">
                  Due Today<br />
                  <br />
                </td>
                <td valign="top">{{ formatAmount(quoteTotal) }}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <hr />
          <br />
          <p style="font-size: 13px; line-height: 20px">
            NSSI Accidental Damage Add-on Waiting Period: There is a 30 day
            waiting period for personal property claims resulting from
            accidental damage. Damages that occur within this waiting period
            will not be covered.
          </p>
          <p style="font-size: 13px; line-height: 20px">
            PAYMENTS: You understand that your account will be charged
            automatically monthly, 4-pay or annually based on the “Payment
            Option” you selected.
          </p>
          <p style="font-size: 13px; line-height: 20px">
            Fraud Notice: Any person who, with intent to defraud or knowing that
            he is facilitating a fraud against an insurer, submits an
            application or files a claim containing a false or deceptive
            statement is guilty of insurance fraud.
          </p>
          <p style="font-size: 13px; line-height: 20px">
            By clicking "Purchase Policy", I acknowledge that I have read and
            understand the applicable
            <a class="javascriptlink" @click.prevent="showDisclosuresModal()"
              >notice of cancellation,
            </a>
            &amp;
            <a
              class="javascriptlink"
              @click.prevent="showPaymentAuthorizationModal()"
              >recurring payment authorization.
            </a>
            I acknowledge that I am 18 years of age and have read and agree to
            the above terms.
          </p>
        </div>
      </div>
      <!--------------------------->
      <div class="spacer"></div>
    </div>
    <!--------------------------------------------------->
    <div style="text-align: center">
      <button :disabled="issuingPolicies" @click="goToPage('quote-done')">
        Purchase Policy
      </button>
    </div>
    <br /><br /><br /><br />
    <base-modal name="DisclosuresModal">
      <disclosures-modal />
    </base-modal>
    <base-modal name="PaymentAuthorizationModal">
      <payment-authorization-modal />
    </base-modal>
  </section>
</template>

<script lang="ts" setup>
import { LocalDate, DateTimeFormatter } from "@js-joda/core";
import { PaymentOptions } from "@/models/QuoteInsurance";
import {
  maskedCardNumber,
  billingDayWithOrdinal,
  formatAmount,
  calculateQuoteTotal,
} from "@/utils/Utils";
import DisclosuresModal from "@/views/modals/context/DisclosuresModal.vue";
import PaymentAuthorizationModal from "@/views/modals/context/PaymentAuthorizationModal.vue";
import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { Defaults } from "@/models/Defaults";
import { UserData } from "@/api/UserData";
import { AssurantData } from "@/api/AssurantData";
import {
  rentersNextPaymentDateFormated,
  nssiNextPaymentDateFormated,
  formatAmountWithoutCents,
} from "@/utils/Utils";
import { watch } from "vue";
import { ref, computed, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import BaseModal from "@/views/modals/BaseModal.vue";
import Modals from "@/utils/Modals";
import useModal from "@/hooks/useModal";

const { toggleModal } = useModal();

const title = "Review";
const loading = ref(false);
const issuingPolicies = ref(false);
const refName = ref(null);
const disclosuresModal = ref(null);
const paymentAuthorizationModal = ref(null);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;

watch(user, (current) => {
  if (!current.loggedIn) {
    quote.setQuoteStep("quote-account");
  }
});

async function goToPage(command: string) {
  // Re-submit protection
  if (issuingPolicies.value) {
    return;
  }

  loading.value = true;
  issuingPolicies.value = true;
  try {
    await UserData.fetchUser(); //TODO is this needed?
    if (quote.rentersInsurance && !quote.assurantPassed) {
      const result = await AssurantData.issuePolicy(quote);
      if (result.error) {
        quote.assurantPassed = false;
        quote.assurantPolicyError = result.message;
        issuingPolicies.value = false;
        quote.setQuoteStep("quote-done-assurant-failed-api");
        return;
      } else {
        quote.assurantPassed = true;
        quote.rentersInsurance.policyNumber =
          result.result.transactionDetails.policyId;
        quote.assurantPolicyError = "";
        if (result?.result?.transactionDetails?.policyId) {
          try {
            const transactionDetails = result.result.transactionDetails;
            const policyHolder = result.result.policyHolderDetails;
            const billing = result.result.billingDetails;
            await NssiData.storeAssurantPolicy(
              transactionDetails,
              policyHolder,
              billing
            );
          } catch (error) {
            // Continue execution
          }
        }
      }
    }
    if (quote.personalInsurance && !quote.nssiPassed) {
      const cartId = await NssiData.toRemote(quote);
      console.log("Cart ID:", cartId);
      const userDataAll = await NssiData.getUserData();
      console.log("User Data for NSSI:", userDataAll);
      const result = await NssiData.issuePolicy(quote, userDataAll, cartId);
      console.log("result of IssuePolicy", result);
      if (result.error) {
        quote.nssiPassed = false;
        quote.nssiPolicyError = result.message;
        //saveStorage();
      } else {
        quote.nssiPassed = true;
        quote.personalInsurance.transactionId = result.policy;
        //quote.personalInsurance.transactionId = result.policy.PolicyID;
        //quote.personalInsurance.policyNumber = result.policy.PolicyNumber;
        quote.nssiPolicyError = "";
      }
    }
  } catch (error) {
    console.log("err on Assurant or NSSI API");
    //TODO
  }
  issuingPolicies.value = false;
  let nssiCheckFlag = true;
  if (quote.personalInsurance && !quote.nssiPassed) {
    nssiCheckFlag = false;
  }
  if (quote.assurantPassed && nssiCheckFlag) {
    loading.value = false;
    quote.setQuoteStep(command);
  }
}

const rentersNextPaymentDate = computed(() => {
  return rentersNextPaymentDateFormated(quote);
});
const nssiNextPaymentDate = computed(() => {
  return nssiNextPaymentDateFormated(quote);
});

const quoteCoverage = async () => {
  quote.setQuoteStep("quote-quote");
};

function quoteCheckoutPayment() {
  quote.setQuoteStep("quote-checkout-payment");
}

function quoteCheckout() {
  quote.setQuoteStep("quote-checkout");
}

function formatDate(value: string) {
  if (value) {
    return LocalDate.parse(value).format(
      DateTimeFormatter.ofPattern("M/d/yyyy")
    );
  }
}

// function formatAmountWithoutCents(value: number): string {
//   return formatAmountWithoutCents(value);
// }

// function formatAmount(value: number): string {
//   return formatAmount(value);
// }

function formatPaymentOption(value: any) {
  const num = Number(value) as PaymentOptions;
  switch (num) {
    case PaymentOptions.Monthly:
      return "Monthly";
    case PaymentOptions.Annual:
      return "Annual";
    case PaymentOptions.FourPay:
      return "4 Pay";
    default:
      return "Unknown";
  }
}

function formatCardNumber(cardNumber: string): string {
  return maskedCardNumber(cardNumber);
}

function formatBillingDay(billingDay: number): string {
  return billingDayWithOrdinal(billingDay);
}

function showDisclosuresModal() {
  toggleModal(Modals.DISCLOSURES_MODAL.label);
}

function showPaymentAuthorizationModal() {
  toggleModal(Modals.PAYMENT_AUTHORIZATION_MODAL.label);
}

const processingFee: ComputedRef<number> = computed(() => {
  return quote.personalInsurance.paymentOption == PaymentOptions.Monthly
    ? quote.monthlyProcessingFee
    : quote.processingFee;
});

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});

function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
}
</script>
